import { useSnackbar } from 'notistack'
import { projectService } from 'services/projectsService'
import { handleErrorMessage, resolveAndDownloadBlob } from 'utils/helpers'

const useTaskFileDownloader = () => {
  const { enqueueSnackbar } = useSnackbar()

  const downloadTaskFile = (file) => {
    projectService
      .downloadProjectTaskFile(file.projectId, file.taskId, file.id)
      .then((res) => {
        resolveAndDownloadBlob(res, file.fileName)
        enqueueSnackbar('Pobieranie pliku.', { variant: 'success' })
      })
      .catch((err) =>
        enqueueSnackbar(handleErrorMessage(err, 'Coś poszło nie tak.'), {
          variant: 'error',
        })
      )
  }

  return { downloadTaskFile }
}

export default useTaskFileDownloader
